<template>
  <div class="content TelemarketingGuard">
    <!-- <van-row style="color: #9B9EA3;font-size: .26rem;line-height: .7rem;padding-left: .3rem;">
    		到期时间：2020年11月25日 23:59:59
    	</van-row> -->
    <van-row style="background-color: #fff; padding: 0.3rem 0.35rem">
      <van-col span="24"><span style="font-size: 0.32rem; color: #303133">导入量：{{ chatData.totalCount }}</span></van-col>
      <van-col span="24">
        <div id="echarts" style="width: 100%; height: 6rem"></div>
      </van-col>
    </van-row>
    <van-row style="background-color: #fff; padding: 0 0.35rem; margin-top: 0.2rem">
      <div class="item">
        <div class="item-title">
          <span>按来源统计</span>
          <van-icon name="arrow" @click="more" />
        </div>
        <div class="item-body">
          <hr size="1" color="#F6F6F7" />
          <div class="table">
            <div class="table-body">
              <van-row class="table-null" v-if="list.length == 0">未查询到数据</van-row>
              <van-row class="table-tr" style="font-size: 0.24rem; color: #606266; line-height: 0.4rem" v-for="(item, index) in list" :key="index">
                <van-col span="12">
                  <font style="font-size: 0.32rem; color: #303133">{{
                    item.importTitle
                  }}</font>
                </van-col>
                <van-col span="12" style="text-align: right">
                  <font style="font-size: 0.2rem; color: #606266">导入量</font>&nbsp;
                  <font style="
                      font-size: 0.35rem;
                      color: #ff0044;
                      font-weight: bold;
                    ">{{ item.totalCount }}</font>
                </van-col>
                <van-col span="24">
                  <span style="
                      font-size: 0.2rem;
                      color: #909399;
                      display: flex;
                      align-items: center;
                    ">
                    <van-icon name="clock-o" />&nbsp;
                    <font>{{ item.createTime }}</font>
                  </span>
                </van-col>
                <van-col span="12">有效号码：{{ item.validCount }}（{{
                    item.validRate
                  }}%）</van-col>
                <van-col span="12">未拨号码：{{ item.unCallCount }}（{{
                    item.unCallRate
                  }}%）</van-col>
                <van-col span="12">风险号码：{{ item.blackCount }}（{{
                    item.blackRate
                  }}%）</van-col>
                <van-col span="12">重复号码：{{ item.replaceCount }}（{{
                    item.replaceRate
                  }}%）</van-col>
              </van-row>
            </div>
          </div>
        </div>
      </div>
    </van-row>
  </div>
</template>
<script type="text/javascript">
import axios from "axios";
import Echarts from "echarts";
import { queryImportMainPage } from "../../api";
export default {
  name: "TelemarketingGuard",
  data() {
    return {
      token: "",
      echarts: "",
      chatData: {},
      list: [],
    };
  },
  methods: {
    more() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //判断iPhone|iPad|iPod|iOS
        // alert("ios")
        window.webkit.messageHandlers.showMessage.postMessage(
          window.location.origin + "/TelemarketingGuardList"
        );
      } else if (/(Android)/i.test(navigator.userAgent)) {
        //判断Android
        // alert("Android")
        organization.onOpenSalesGuard(
          "更多",
          window.location.origin + "/TelemarketingGuardList"
        );
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return "";
    },
    queryImportMainPage() {
      queryImportMainPage().then((res) => {
        if (res.code == 1) {
          this.chatData = res.data.headBean;
          this.list = res.data.recordsListBeanList;
          this.setChart(this.chatData);
        } else {
          this.$toast("错误信息:" + res.message);
        }
      });
    },
    setChart(data) {
      var option = {
        title: {
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          right: 0,
          data: ["有效号码", "未拨号码", "重复号码", "风险号码"],
        },
        series: [
          {
            name: "电销卫士",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            color: ["#9EBEFF", "#32E0C4", "#FCB886", "#D89CF6"],
            center: ['40%', '50%'],
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: data.validCount, name: "有效号码" },
              { value: data.unCallCount, name: "未拨号码" },
              { value: data.replaceCount, name: "重复号码" },
              { value: data.blackCount, name: "风险号码" },
            ],
          },
        ],
      };
      this.echarts.setOption(option);
    },
  },
  mounted() {
    this.token = this.getQueryString("token");
    sessionStorage.setItem("token", this.token);
    sessionStorage.setItem('newloginUser', this.getQueryString("newloginUser"));
    sessionStorage.setItem('actCode', this.getQueryString("actCode"));
    sessionStorage.setItem('ip', this.getQueryString("ip"));
    this.echarts = Echarts.init(document.getElementById("echarts"));
    this.queryImportMainPage();
  },
};
</script>
<style type="text/css">
.TelemarketingGuard .item-title {
  color: #303133;
  font-size: 0.32rem;
  line-height: 0.94rem;
  position: relative;
}
.TelemarketingGuard .item-title .van-icon {
  position: absolute;
  right: 0;
  top: 0.31rem;
}
</style>


// WEBPACK FOOTER //
// src/views/app/TelemarketingGuard.vue


// WEBPACK FOOTER //
// src/views/app/TelemarketingGuard.vue